import React from 'react';
import { Link } from 'react-router-dom';
import language from '../../../../utils/LanguageSettings';
import translations from '../../../../text/get-started-translations.json';

const Keywords: React.FC<{ keywords: any[] }> = ({ keywords }) => {
  const pageTranslations = translations[language];
  return (
    <div className="side-sections pt-5">
      <h3>{pageTranslations.PopularKeywords}</h3>
      <div className="article-tags">
        {keywords.map((keyword: any) => (
          <Link key={keyword.id} to={`/blog/filter#${keyword.Hashtags}`} className="btn">#{keyword.Hashtags}</Link>
        ))}
      </div>
    </div>
  );
};

export default Keywords;